import {fetchDataAsync} from "../../../Services/Utils";

async function callApi(api, setError, args) {
    return await fetchDataAsync({
        asyncFn: api,
        menuName: "Mutasi Barang",
        setError: setError,
        args: args,
    });
}

export const service = {
    callApi,
};